module.exports = __webpack_public_path__ + "static/media/account.d2db7525.svg";